<div class="container">

  <app-header-dialog [iconName]="'flag_circle'">
    Paises
  </app-header-dialog>

  <div class="content">

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Pais</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.country"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.country.hasError('required')">
          O Nome é obrigatório
        </mat-error>
      </mat-form-field>

    </form>

    <div>

      <div style="width: 100%; text-align: center;">
        <p>Para adicionar novos países use as bandeiras deste site:
          <a target='_blank' href='https://flagicons.lipis.dev'>https://flagicons.lipis.dev</a>
        </p>
      </div>

      <div class='img-input'>
        <input #file type="file" accept='image/*' style='display:none' (change)="previewImage($event)" />
      </div>
      <div class="post-image">
        <img [src]="storedImage" *ngIf="storedImage">
      </div>

      <div class="button-image">
        <button mat-raised-button (click)='file.click()'>
          <mat-icon class='icon-add'>image_search</mat-icon>
        </button>
      </div>

    </div>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button mat-raised-button (click)="matDialogRef.close(['insert',entityForm, objectImage])"
      [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)="matDialogRef.close(['update',entityForm, objectImage])"
      [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>